<template>
    <span class="badge" v-if="value">
        <span v-if="value <= max">{{value}}</span>
        <span v-else class="el-icon-more"></span>
    </span>
</template>

<script>
export default {
  name: 'v-badge',
  props: {
    value: Number,
    max: {
      type: Number,
      default: 99
    }
  }
}
</script>

<style lang="less" scoped>
.badge {
    width: 20px;
    height: 27px;
    line-height: 27px;
    text-align: center;
    font-size: 12px;
    color: #fff;
    display: inline-block;
    margin-left: 2px;
    position: absolute;
    top: -8px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjY2NDhBRTlBOTIxNzExRTc4RTE3REQ2ODJGQzYyNTgzIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjY2NDhBRTlCOTIxNzExRTc4RTE3REQ2ODJGQzYyNTgzIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NjY0OEFFOTg5MjE3MTFFNzhFMTdERDY4MkZDNjI1ODMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NjY0OEFFOTk5MjE3MTFFNzhFMTdERDY4MkZDNjI1ODMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4VhqJ9AAABEUlEQVR42qyV3QoBQRiGd9HmDnCAUkoOFbfB4sQNOHDgJ3ITQspd+M8lOCIX4BSJa0B4P30jjVXszltPu7Uzz3x9zczqp2pNs4gBTJAFKeADd3ACSzADY3CRJ3osZCTpgLDFtwhTADtQY/Errrd3HfTA6ItMTojHdnnuR4V9UNL+T5ULq7xXmLMpEylzz59Cg3vmNNQug4R57ofTBMlFwrSmLlkSJhUKEyQMKBT6XF82t924SXhQKDyScK1QuCLhQKFwSsIJ2CuQkWNEwrM4hw5TJ5c4y1TlxoGsJVonhHEQsylrg6Z8Hxb5eQOLH3u6BRnQkG9sL4jyvTbkfWnwlWby0fTzYkf+Bcx57FVe5SHAAA7zMJmZO6XNAAAAAElFTkSuQmCC) no-repeat 50%;
    span {
        position: absolute;
        top: 50%;
        left: 50%;
        font-size: 14px;
        display: inline-block;
        transform: translate(-50%, -50%) scale(0.8);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/framework/widgets/badge.vue